"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BettingEvents = void 0;
var Subject_1 = require("rxjs/Subject");
var BehaviorSubject_1 = require("rxjs/BehaviorSubject");
require("rxjs/add/operator/map");
var BettingEvents = /** @class */ (function () {
    function BettingEvents() {
        this.subjects = new Map();
        this.eventsAvailability$ = new BehaviorSubject_1.BehaviorSubject(new Map());
    }
    BettingEvents.prototype.subscribe = function (eventType, handler) {
        var _this = this;
        if (!this.subjects.has(eventType)) {
            this.subjects.set(eventType, new Subject_1.Subject());
        }
        var subject$ = this.subjects.get(eventType);
        var eventAvailability = this.eventsAvailability$.getValue();
        if (!this.checkIsEventAvailable(eventType)) {
            this.eventsAvailability$.next(eventAvailability.set(eventType, true));
        }
        var subscription = subject$.subscribe(function (payload) {
            return handler(payload);
        });
        subscription.add(function () {
            if (subject$.observers.length)
                return;
            _this.eventsAvailability$.next(eventAvailability.set(eventType, false));
        });
        return function () {
            subscription.unsubscribe();
        };
    };
    BettingEvents.prototype.checkIsEventAvailable$ = function (eventType) {
        return this.eventsAvailability$.map(function (events) { return !!events.get(eventType); });
    };
    BettingEvents.prototype.checkIsEventAvailable = function (eventType) {
        return !!this.eventsAvailability$.getValue().get(eventType);
    };
    BettingEvents.prototype.dispatch = function (eventType, payload) {
        var subject$ = this.subjects.get(eventType);
        if (!subject$ || !subject$.observers.length)
            return;
        subject$.next(payload);
    };
    return BettingEvents;
}());
exports.BettingEvents = BettingEvents;
//# sourceMappingURL=BettingEvents.js.map